import React, { useState, useEffect } from "react";
import PageLayout from "../../PageLayout/PageLayout";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import classes from "./BasicInfo.module.css";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { Button } from "../../../../../stories/Button/Button";
import { Input } from "../../../../../stories/Input/Input";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import {
  ArrowUpRightBlue,
  AmountYouWillEarnCard,
} from "../../../../../constant/imagePath";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import BasicInfoMobile from "./BasicInfoMobile";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

export const BasicInfoDesktop = () => {
  const location = useLocation()?.state;
  const dispatch = useDispatch();
  const setLessonData = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );
  const startWorkAndGetPaid = useSelector(
    (state) => state.onBoardingReducer.price
  );
  const setAvailabilityData = useSelector(
    (state) => state.onBoardingReducer.setAvailability
  );

  const [sportstype, setSportstype] = useState([
    { label: "Tennis", value: "Tennis" },
  ]);

  const [sessionPlan, setSessionPlan] = useState(
    setLessonData?.sessionPlan ? setLessonData?.sessionPlan : ""
  );
  const [priceForAnHour, setPriceForAnHour] = useState(
    startWorkAndGetPaid?.priceForAnHour
      ? startWorkAndGetPaid?.priceForAnHour
      : ""
  );
  const [breakBetween, setbreakBetween] = useState(
    setAvailabilityData?.breakBetween ? setAvailabilityData?.breakBetween : ""
  );
  const [intervalBetween, setIntervalBetween] = useState(
    setAvailabilityData?.intervalBetween
      ? setAvailabilityData?.intervalBetween
      : ""
  );

  useEffect(() => {
    dispatch(setActiveTab("basic-info"));
  }, [location == undefined]);

  function saveDataIntoRedux() {
    // For Session Plan
    dispatch(
      setPersonalData("set-lesson", {
        ...setLessonData,
        sessionPlan,
      })
    );
    // For Lesson Price
    dispatch(
      setPersonalData("price", { ...startWorkAndGetPaid, priceForAnHour })
    );
    // For Break in between lessons
    dispatch(
      setPersonalData("setAvailability", {
        ...setAvailabilityData,
        breakBetween,
        intervalBetween,
      })
    );
  }

  console.log({ setLessonData });

  return (
    <div className={[classes.BasicInfoScreen].join(" ")}>
      <Container
        fluid
        className={[classes.container, "p-0", classes.mb52].join(" ")}
      >
        <Row className={[classes.mb52, "g-0"].join(" ")}>
          <Col md={12}>
            <div className={`${classes.edit_heading_main_div}`}>
              <div>
                <h3
                  style={{
                    ...Fonts.h3,
                    color: Colors.neutralShadesOfNero,
                  }}
                >
                  Edit Lesson Info
                </h3>
              </div>
              <div className={`${classes.edit_heading_button_div}`}>
                <Button
                  primary={false}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    marginRight: "12px",
                    ...Fonts.b2,
                  }}
                >
                  Profile preview
                </Button>
                <Button
                  primary={true}
                  size="Medium"
                  customStyle={{
                    padding: "14px 24px",
                    width: "max-content",
                    ...Fonts.b2,
                  }}
                  onClick={saveDataIntoRedux}
                >
                  Save changes
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row className={`g-0 ${classes.row}`}>
          <Col md={12}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={`${classes.mb32}`}
            >
              General
            </h5>
          </Col>
          <Col md={12} className={[classes.mb32].join(" ")}>
            <DropDown
              state={sportstype}
              setter={setSportstype}
              options={[]}
              label="Sport type"
              placeholder=""
            />
          </Col>
          <Col md={12} className={[classes.mb80].join(" ")}>
            <TextArea
              state={sessionPlan}
              setter={setSessionPlan}
              label="Tell students about your session plan"
              placeholder="What will you cover in the lesson? What should students expect?"
            />
          </Col>

          <Col md={12} className={[classes.mb48].join(" ")}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={[classes.mb32]}
            >
              Break in-between lessons
            </h5>
            <div className={[classes.mb32].join(" ")}>
              <div
                className={[classes.breakinlessondiv, classes.mb32].join(" ")}
              >
                <div style={{ width: "430px" }}>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    How much time would you need for a break in-between lessons?
                  </p>
                </div>
                <div style={{ position: "relative" }}>
                  <Input
                    state={breakBetween}
                    setter={setbreakBetween}
                    customStyle={{ width: "100px", marginLeft: "24px" }}
                    type={"number"}
                    inputStyle={{ paddingRight: "38px" }}
                    placeholder=""
                  />
                  <span
                    className={classes.postFixText}
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    min
                  </span>
                </div>
              </div>
              <hr />
            </div>
            <div className={[classes.mb32].join(" ")}>
              <div
                className={[classes.breakinlessondiv, classes.mb32].join(" ")}
              >
                <div style={{ width: "430px" }}>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    You are available at multipe locations. How much time would
                    you like in-between lessons at different locations?
                  </p>
                </div>
                <div style={{ position: "relative" }}>
                  <Input
                    state={intervalBetween}
                    setter={setIntervalBetween}
                    customStyle={{ width: "100px", marginLeft: "24px" }}
                    type={"number"}
                    inputStyle={{ paddingRight: "38px" }}
                    placeholder=""
                  />
                  <span
                    className={classes.postFixText}
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfNero,
                    }}
                  >
                    min
                  </span>
                </div>
              </div>
              <hr />
            </div>
          </Col>

          <Col md={12}>
            <h5
              style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
              className={[classes.mb32]}
            >
              Set your lesson price
            </h5>
          </Col>

          <Col
            md={12}
            className={`${[classes.BasicInfoPriceCard].join(" ")}`}
            style={{ border: `1px solid ${Colors.neutralShadesOfWhisper}` }}
          >
            <Row className="position-relative">
              <Col md={6}>
                <p>Set the price for 1 hour lessons USD</p>
                <div className={classes.BasicInfoPerHour}>
                  <Input
                    placeholder=""
                    customStyle={{ width: "120px" }}
                    type="number"
                    state={priceForAnHour}
                    setter={(e) => {
                      if (e.length < 5) {
                        setPriceForAnHour(e);
                      }
                    }}
                  />
                  <span
                    style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}
                  >
                    /1 hour
                  </span>
                </div>
                <p
                  className={`${[classes.lytesnapCharges].join(" ")}`}
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                >
                  Lytesnap charges <span style={{ ...Fonts.h8 }}>10%</span> of
                  your listed lesson price
                </p>
                <LinkButtonWithIcon
                  text={"System fee info"}
                  rightIcon={ArrowUpRightBlue}
                  primary={true}
                  iconStyle={{ margin: "0px" }}
                  customStyle={{
                    ...Fonts.b2,
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                />
              </Col>
              <Col md={6} className={classes.cardPosition}>
                <div className={classes.cardInnerData}>
                  <img src={AmountYouWillEarnCard} />
                  <h3 style={{ ...Fonts.h3, color: Colors.white }}>
                    ${priceForAnHour}
                  </h3>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const BasicInfo = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <BasicInfoMobile /> : <BasicInfoDesktop />;
};

export default BasicInfo;
